import React from "react";
import {
    Users,
    UserPlus,
    CreditCard,
    IndianRupee,
    Building2,
    Heart,
    MessageSquare,
    TrendingUp,
    TrendingDown,
    Eye,
    ArrowUpRight,
    CheckCircle,
    Clock,
    XCircle,
    Crown,
    Star,
    UserCheck,
} from "lucide-react";

const monthlyRegistrations = [
    { month: "May", value: 72 },
    { month: "Jun", value: 95 },
    { month: "Jul", value: 110 },
    { month: "Aug", value: 126 },
    { month: "Sep", value: 142 },
    { month: "Oct", value: 86 },
];

const branches = [
    {
        name: "Erode Main Branch",
        members: 420,
        subscriptions: 285,
        growth: 14.0,
    },
    {
        name: "Coimbatore Branch",
        members: 315,
        subscriptions: 210,
        growth: 9.4,
    },
    {
        name: "Salem Branch",
        members: 245,
        subscriptions: 165,
        growth: 10.0,
    },
    {
        name: "Tiruppur Branch",
        members: 185,
        subscriptions: 118,
        growth: 12.4,
    },
    {
        name: "Namakkal Branch",
        members: 85,
        subscriptions: 57,
        growth: 18.8,
    },
];

const recentMembers = [
    {
        id: "JP10025",
        name: "Arun Kumar",
        gender: "Male",
        age: 29,
        branch: "Erode Main Branch",
        plan: "Premium",
        status: "Active",
    },
    {
        id: "JP10024",
        name: "Priya S",
        gender: "Female",
        age: 26,
        branch: "Coimbatore Branch",
        plan: "Gold",
        status: "Active",
    },
    {
        id: "JP10023",
        name: "Karthik R",
        gender: "Male",
        age: 31,
        branch: "Salem Branch",
        plan: "Basic",
        status: "Active",
    },
    {
        id: "JP10022",
        name: "Divya M",
        gender: "Female",
        age: 28,
        branch: "Tiruppur Branch",
        plan: "Premium",
        status: "Pending",
    },
    {
        id: "JP10021",
        name: "Suresh Kumar",
        gender: "Male",
        age: 30,
        branch: "Erode Main Branch",
        plan: "Gold",
        status: "Active",
    },
];

const recentPayments = [
    {
        id: "PAY10254",
        member: "Arun Kumar",
        plan: "Premium",
        amount: "₹5,900",
        method: "UPI",
        status: "Success",
        date: "05 Oct 2026",
    },
    {
        id: "PAY10253",
        member: "Priya S",
        plan: "Gold",
        amount: "₹11,800",
        method: "Card",
        status: "Success",
        date: "05 Oct 2026",
    },
    {
        id: "PAY10252",
        member: "Karthik R",
        plan: "Basic",
        amount: "₹2,950",
        method: "UPI",
        status: "Pending",
        date: "04 Oct 2026",
    },
    {
        id: "PAY10251",
        member: "Divya M",
        plan: "Premium",
        amount: "₹5,900",
        method: "Net Banking",
        status: "Success",
        date: "04 Oct 2026",
    },
];

function Dashboard() {
    const maxRegistration = Math.max(
        ...monthlyRegistrations.map((item) => item.value)
    );

    return (
        <div className="dashboard-page">

            {/* PAGE HEADER */}
            <div className="dashboard-page-header">
                <div>
                    <h1>Dashboard</h1>
                    <p>
                        Welcome back! Here's what's happening with Jodi Point
                        Matrimonial Services.
                    </p>
                </div>

                <div className="dashboard-date">
                    <span>05 October 2026</span>
                </div>
            </div>

            {/* SUMMARY CARDS */}
            <div className="dashboard-summary-grid">

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon blue">
                            <Users size={23} />
                        </div>

                        <span className="summary-growth positive">
                            <TrendingUp size={14} />
                            12.5%
                        </span>
                    </div>

                    <div className="summary-card-value">1,250</div>
                    <div className="summary-card-label">
                        Total Members
                    </div>

                    <div className="summary-card-footer">
                        <span>vs last month</span>
                    </div>
                </div>

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon pink">
                            <UserCheck size={23} />
                        </div>

                        <span className="summary-growth positive">
                            <TrendingUp size={14} />
                            8.7%
                        </span>
                    </div>

                    <div className="summary-card-value">835</div>
                    <div className="summary-card-label">
                        Subscription Members
                    </div>

                    <div className="summary-card-footer">
                        <span>66.8% of total members</span>
                    </div>
                </div>

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon purple">
                            <Building2 size={23} />
                        </div>

                        <span className="summary-growth positive">
                            <TrendingUp size={14} />
                            2 New
                        </span>
                    </div>

                    <div className="summary-card-value">12</div>
                    <div className="summary-card-label">
                        Total Branches
                    </div>

                    <div className="summary-card-footer">
                        <span>10 Active branches</span>
                    </div>
                </div>

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon orange">
                            <UserPlus size={23} />
                        </div>

                        <span className="summary-growth positive">
                            <TrendingUp size={14} />
                            15.2%
                        </span>
                    </div>

                    <div className="summary-card-value">86</div>
                    <div className="summary-card-label">
                        New Registrations
                    </div>

                    <div className="summary-card-footer">
                        <span>This month</span>
                    </div>
                </div>

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon green">
                            <IndianRupee size={23} />
                        </div>

                        <span className="summary-growth positive">
                            <TrendingUp size={14} />
                            18.4%
                        </span>
                    </div>

                    <div className="summary-card-value">
                        ₹4.82L
                    </div>

                    <div className="summary-card-label">
                        Total Revenue
                    </div>

                    <div className="summary-card-footer">
                        <span>This month</span>
                    </div>
                </div>

                <div className="dashboard-summary-card">
                    <div className="summary-card-top">
                        <div className="summary-icon red">
                            <MessageSquare size={23} />
                        </div>

                        <span className="summary-growth negative">
                            <TrendingDown size={14} />
                            3.2%
                        </span>
                    </div>

                    <div className="summary-card-value">72</div>
                    <div className="summary-card-label">
                        New Enquiries
                    </div>

                    <div className="summary-card-footer">
                        <span>Needs follow-up</span>
                    </div>
                </div>

            </div>

            {/* MAIN TWO COLUMN */}
            <div className="dashboard-two-column">

                {/* REGISTRATION CHART */}
                <div className="dashboard-card registration-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Member Registration Overview</h2>
                            <p>Monthly new member registrations</p>
                        </div>

                        <select className="dashboard-select">
                            <option>Last 6 Months</option>
                            <option>Last 12 Months</option>
                            <option>This Year</option>
                        </select>
                    </div>

                    <div className="registration-chart">

                        {monthlyRegistrations.map((item) => (
                            <div
                                className="registration-column"
                                key={item.month}
                            >
                                <div className="registration-value">
                                    {item.value}
                                </div>

                                <div className="registration-bar-wrapper">
                                    <div
                                        className="registration-bar"
                                        style={{
                                            height: `${(item.value / maxRegistration) * 100}%`,
                                        }}
                                    ></div>
                                </div>

                                <div className="registration-month">
                                    {item.month}
                                </div>
                            </div>
                        ))}

                    </div>

                    <div className="chart-footer">
                        <div>
                            <span className="chart-dot blue-dot"></span>
                            New Registrations
                        </div>

                        <strong>
                            631 registrations
                        </strong>
                    </div>

                </div>

                {/* SUBSCRIPTION OVERVIEW */}
                <div className="dashboard-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Subscription Overview</h2>
                            <p>Current active subscriptions</p>
                        </div>

                        <Crown
                            size={21}
                            className="header-icon"
                        />
                    </div>

                    <div className="subscription-overview">

                        <div className="subscription-item basic">
                            <div className="subscription-icon">
                                <Star size={20} />
                            </div>

                            <div className="subscription-info">
                                <div className="subscription-title">
                                    Basic
                                </div>

                                <div className="subscription-progress">
                                    <div
                                        className="subscription-progress-fill"
                                        style={{ width: "48%" }}
                                    ></div>
                                </div>
                            </div>

                            <div className="subscription-count">
                                287
                            </div>
                        </div>

                        <div className="subscription-item premium">
                            <div className="subscription-icon">
                                <Star size={20} />
                            </div>

                            <div className="subscription-info">
                                <div className="subscription-title">
                                    Premium
                                </div>

                                <div className="subscription-progress">
                                    <div
                                        className="subscription-progress-fill"
                                        style={{ width: "67%" }}
                                    ></div>
                                </div>
                            </div>

                            <div className="subscription-count">
                                394
                            </div>
                        </div>

                        <div className="subscription-item gold">
                            <div className="subscription-icon">
                                <Crown size={20} />
                            </div>

                            <div className="subscription-info">
                                <div className="subscription-title">
                                    Gold
                                </div>

                                <div className="subscription-progress">
                                    <div
                                        className="subscription-progress-fill"
                                        style={{ width: "31%" }}
                                    ></div>
                                </div>
                            </div>

                            <div className="subscription-count">
                                154
                            </div>
                        </div>

                    </div>

                    <div className="subscription-total">
                        <span>Total Active Subscriptions</span>
                        <strong>835</strong>
                    </div>

                </div>

            </div>

            {/* SECOND ROW */}
            <div className="dashboard-two-column">

                {/* BRANCH PERFORMANCE */}
                <div className="dashboard-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Branch Performance</h2>
                            <p>Members and subscription overview</p>
                        </div>

                        <button className="view-all-btn">
                            View All
                            <ArrowUpRight size={15} />
                        </button>
                    </div>

                    <div className="branch-list">

                        {branches.map((branch, index) => (
                            <div
                                className="branch-row"
                                key={branch.name}
                            >
                                <div className="branch-number">
                                    {String(index + 1).padStart(2, "0")}
                                </div>

                                <div className="branch-details">
                                    <div className="branch-name">
                                        {branch.name}
                                    </div>

                                    <div className="branch-meta">
                                        <span>
                                            {branch.members} Members
                                        </span>

                                        <span>
                                            {branch.subscriptions} Subscriptions
                                        </span>
                                    </div>
                                </div>

                                <div className="branch-growth">
                                    <TrendingUp size={14} />
                                    {branch.growth}%
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

                {/* ENQUIRY OVERVIEW */}
                <div className="dashboard-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Enquiry Overview</h2>
                            <p>Current enquiry status</p>
                        </div>

                        <MessageSquare
                            size={21}
                            className="header-icon"
                        />
                    </div>

                    <div className="enquiry-overview">

                        <div className="enquiry-stat">
                            <div className="enquiry-stat-icon blue">
                                <MessageSquare size={18} />
                            </div>

                            <div>
                                <strong>72</strong>
                                <span>New</span>
                            </div>
                        </div>

                        <div className="enquiry-stat">
                            <div className="enquiry-stat-icon orange">
                                <Clock size={18} />
                            </div>

                            <div>
                                <strong>65</strong>
                                <span>Follow-up</span>
                            </div>
                        </div>

                        <div className="enquiry-stat">
                            <div className="enquiry-stat-icon green">
                                <CheckCircle size={18} />
                            </div>

                            <div>
                                <strong>78</strong>
                                <span>Converted</span>
                            </div>
                        </div>

                        <div className="enquiry-stat">
                            <div className="enquiry-stat-icon red">
                                <XCircle size={18} />
                            </div>

                            <div>
                                <strong>26</strong>
                                <span>Closed</span>
                            </div>
                        </div>

                    </div>

                    <div className="conversion-box">
                        <div>
                            <span>Conversion Rate</span>
                            <strong>32.4%</strong>
                        </div>

                        <div className="conversion-progress">
                            <div
                                className="conversion-progress-fill"
                                style={{ width: "32.4%" }}
                            ></div>
                        </div>
                    </div>

                </div>

            </div>

            {/* RECENT MEMBERS */}
            <div className="dashboard-card">

                <div className="dashboard-card-header">
                    <div>
                        <h2>Recent Registrations</h2>
                        <p>Latest members registered in the system</p>
                    </div>

                    <button className="view-all-btn">
                        View All
                        <ArrowUpRight size={15} />
                    </button>
                </div>

                <div className="dashboard-table-wrapper">
                    <table className="dashboard-table">

                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Member ID</th>
                                <th>Member Name</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Branch</th>
                                <th>Plan</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {recentMembers.map((member, index) => (
                                <tr key={member.id}>

                                    <td>{index + 1}</td>

                                    <td>
                                        <strong className="member-id">
                                            {member.id}
                                        </strong>
                                    </td>

                                    <td>
                                        <div className="member-name-cell">
                                            <div className="member-avatar">
                                                {member.name
                                                    .charAt(0)
                                                    .toUpperCase()}
                                            </div>

                                            <span>{member.name}</span>
                                        </div>
                                    </td>

                                    <td>{member.gender}</td>

                                    <td>{member.age}</td>

                                    <td>{member.branch}</td>

                                    <td>
                                        <span
                                            className={`plan-badge ${member.plan.toLowerCase()}`}
                                        >
                                            {member.plan}
                                        </span>
                                    </td>

                                    <td>
                                        <span
                                            className={`dashboard-status ${
                                                member.status.toLowerCase()
                                            }`}
                                        >
                                            {member.status}
                                        </span>
                                    </td>

                                    <td>
                                        <button className="table-view-btn">
                                            <Eye size={16} />
                                            View
                                        </button>
                                    </td>

                                </tr>
                            ))}

                        </tbody>

                    </table>
                </div>

            </div>

            {/* PAYMENT + QUICK ACTION */}
            <div className="dashboard-bottom-grid">

                {/* RECENT PAYMENTS */}
                <div className="dashboard-card payment-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Recent Payments</h2>
                            <p>Latest membership payments</p>
                        </div>

                        <button className="view-all-btn">
                            View All
                            <ArrowUpRight size={15} />
                        </button>
                    </div>

                    <div className="payment-list">

                        {recentPayments.map((payment) => (
                            <div
                                className="payment-row"
                                key={payment.id}
                            >

                                <div className="payment-icon">
                                    <CreditCard size={18} />
                                </div>

                                <div className="payment-details">
                                    <strong>
                                        {payment.member}
                                    </strong>

                                    <span>
                                        {payment.id} · {payment.plan}
                                    </span>
                                </div>

                                <div className="payment-amount">
                                    <strong>
                                        {payment.amount}
                                    </strong>

                                    <span>
                                        {payment.date}
                                    </span>
                                </div>

                                <span
                                    className={`payment-status ${payment.status.toLowerCase()}`}
                                >
                                    {payment.status}
                                </span>

                            </div>
                        ))}

                    </div>

                </div>

                {/* QUICK ACTIONS */}
                <div className="dashboard-card">

                    <div className="dashboard-card-header">
                        <div>
                            <h2>Quick Actions</h2>
                            <p>Frequently used modules</p>
                        </div>
                    </div>

                    <div className="quick-actions">

                        <button className="quick-action blue">
                            <div>
                                <Building2 size={21} />
                            </div>
                            <span>Branches</span>
                        </button>

                        <button className="quick-action pink">
                            <div>
                                <Users size={21} />
                            </div>
                            <span>Members</span>
                        </button>

                        <button className="quick-action purple">
                            <div>
                                <Crown size={21} />
                            </div>
                            <span>Plans</span>
                        </button>

                        <button className="quick-action green">
                            <div>
                                <CreditCard size={21} />
                            </div>
                            <span>Payments</span>
                        </button>

                        <button className="quick-action orange">
                            <div>
                                <Heart size={21} />
                            </div>
                            <span>Matches</span>
                        </button>

                        <button className="quick-action red">
                            <div>
                                <TrendingUp size={21} />
                            </div>
                            <span>Reports</span>
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Dashboard;